import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';

import { DemandsDateRangeChange } from '../../../../../Catalog/Interfaces/demands-filter-panel.interface';
import { AvSpinComponent } from '../../../../../Shared/Components/av-spin/av-spin.component';
import { AvPendingDirective } from '../../../../../Shared/Directives/av-pending.directive';
import { COMMON_IMPORTS } from '../../../../../Shared/common-imports';
import { waitState } from '../../../../../Shared/Services/wait-state.util';
import { AllDemandsDateRangeComponent } from '../../../../Demand/Components/Partials/all-demands-date-range/all-demands-date-range.component';

@Component({
  selector: 'app-monitoring-toolbar',
  standalone: true,
  imports: [COMMON_IMPORTS, AllDemandsDateRangeComponent, AvSpinComponent, AvPendingDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './monitoring-toolbar.component.html',
  styleUrl: './monitoring-toolbar.component.scss',
})
export class MonitoringToolbarComponent {
  readonly from = input<string | null>(null);
  readonly to = input<string | null>(null);
  readonly exporting = input<boolean>(false);

  readonly rangeChange = output<DemandsDateRangeChange>();
  readonly exportRequested = output<void>();

  protected readonly exportWait = waitState(computed(() => this.exporting()));
}
